import * as Yup from 'yup'

export default Yup.object().shape({
    firstName: Yup.string().required('Nome é obrigatório!'),
    lastName: Yup.string().required('Sobrenome é obrigatório!'),
    phone: Yup.string().required('Telefone é obrigatório!')
        .test('valid-phone', 'Telefone inválido!', value => {
            // Remova os caracteres _ e ( e verifique se o resultado tem exatamente 11 dígitos
            const digits = value.replace(/[_\s()-]/g, '')
            return /^\d{11}$/.test(digits)
        })
})